import React, { Fragment } from 'react';
import { Input } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';

import ErrorMessage from './errorMessage';

const normalizeUrl = (value) => {
  const result = value.replace(/ /g, '');
  const httpPrefixRegex = /https?:\/\//g;
  return (httpPrefixRegex.test(result) || value.length < 8) ? result : `http://${result}`;
};

const HHUrl = ({
  field, form: { touched, errors, setFieldValue }, otherProps, translate
}) => {
  const hasError = !!(touched[field.name] && errors[field.name]);
  return (
    <Fragment>
      <Input
        type='text'
        label={translate('form.label.url')}
        {...field}
        {...otherProps}
        onChange={e => {
          setFieldValue(field.name, normalizeUrl(e.target.value));
        }}
        error={hasError}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default withLocalize(HHUrl);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhUrl.js